'use client'
import { Button } from '@/components/ui/Button'
import Container from '@/components/ui/Container'
import SectionHeader from '@/components/ui/SectionHeader'
import { useEffect } from 'react'

export default function Error({ error, reset }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <Container className="section-padding">
      <SectionHeader
        title="Something went wrong"
        subtitle="An error occurred while processing your request. Don't worry, these things happen sometimes. Please try again or contact us if the problem persists."
      />
      <div className="mt-16 max-w-xl mx-auto text-center">
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={() => reset()} className="flex-1 sm:flex-none">
            Try again
          </Button>
          <Button
            variant="outline"
            onClick={() => (window.location.href = '/')}
            className="flex-1 sm:flex-none"
          >
            Go home
          </Button>
        </div>
      </div>
    </Container>
  )
}
